import React, {Component} from 'react'
import './styles.css'
import {Formik, Field, Form} from 'formik'
import Header from '../../components/header'
import {PRECISA_LOGAR} from '../../config'
import {connect} from 'react-redux'
import { Redirect } from 'react-router-dom'
import { apiEmployee } from '../../services/apiamrg'
import apiWeather from '../../services/apiweather'
import Image from 'react-bootstrap/Image'

import util from '../../classes/util'

const estadoInicial = {
    name: '',
    information: '',
    thumb: [],
    imagem: '',
    seaport: [],
    id: null,
    latitude: 0,
    longitude: 0,
    redirect: false,
    maxSeaports: null,
    finalizaOperacao: false,
    spanerror1:'',
    spanerror2:'',
}

class AddSeaport extends Component {
    
    state = {
        ...estadoInicial
    }

    componentDidMount = async () => {
        window.scrollTo(0, 0)
        var id = await this.props.match.params.id
        await this.setState({id})
        if(parseInt(id) !== 0){
            await this.setState({seaport: this.props.location.state.seaport})
            await this.loadData(this.props.location.state.seaport)
        }
        console.log(this.props.token)
        console.log(this.state.thumb)
        
    }

   loadData = async (produto) => {
       console.log(produto)
    await this.setState({maxSeaports:produto.id  ,name: produto.name, information: produto.information})
    this.setState({thumb: [...this.state.thumb, `http://ftptrade.ddns.net/amrg/api/pictures/${produto.imagem}`]})
   }

   getMaxSeaports = async () => {
    console.log('get Seaports')
    await apiEmployee.post('getMaxSeaports.php', {
        token: this.props.token
    }).then(
        async res => {
            console.log(res.data)
            await this.setState({maxSeaports: res.data[0].id})
            //console.log(this.state.maxNews)
        },
        async err => alert('erro: ' + err)
    )
}




   toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
   })

   salvarFoto = async () => {
       
        let result = await this.toBase64(this.state.imagem)
        let id_seaport = 'SEAPORT_' + util.completarZerosEsquerda(`${this.state.maxSeaports}`, 6)
        console.log(id_seaport)
        await apiEmployee.post('insertSeaportPicture.php', {
            token: this.props.token,
            id_seaport: this.state.maxSeaports,
            nome: id_seaport,
            picture: result
        }).then(
            async res => {
                if(JSON.stringify(res.data) == 'true'){
                    alert('Seaport Inserido!')
                    await this.setState({finalizaOperacao: true})
                }else{
                    alert('Erro, tente novamente!')
                }
            },
            err => alert(err)
        )         
   }
   
   salvarPorto = async () => {
    
    let arrayNomeCidade = this.state.name.split('/')
    let nomecidade = arrayNomeCidade[0].trim()
     /*await apiWeather.get(`weather?q=${nomecidade}&limit=1&appid=b3d819c395894e533c787503f0e18db7`).then(
        async res => {                 
            if(res.data.coord){
                console.log(JSON.stringify(res.data))
                await this.setState({latitude: res.data.coord.lat, longitude: res.data.coord.lon})
            }else{
                console.log('Sem retorno para a cidade' + nomecidade)
            }
        },
        err => console.log(err)
    )*/
     
       if(parseInt(this.state.id) === 0){
           await apiEmployee.post(`insertSeaport.php`, {
               token: this.props.token,
               values: `'${this.state.name}', '${this.state.imagem}', '${this.state.information}', '${this.state.latitude}', '${this.state.longitude}'` 
           }).then(
                async res => {
                   if(JSON.stringify(res.data) == 'true'){
                    await this.getMaxSeaports()
                    if(this.state.maxSeaports > 0){
                        await this.salvarFoto()
                    }else{
                        alert('erro ao salvar a foto')
                    }
                   }else{
                       alert(JSON.stringify(res.data))
                   }
                },
                async res => await alert(`Erro: ${res.data}`)
           )
       }else{
           if(this.state.imagem != '' && this.state.imagem != null){
            await this.salvarFoto()
           }
           await apiEmployee.post(`updateSeaport.php`, {
               token: this.props.token,
               id_seaport: this.state.id,
               name: this.state.name,
               information: this.state.information,
               latitude: this.state.latitude,
               longitude: this.state.longitude
           }).then(
            async res => {
                console.log(res.data)
                if(res.data === true){
                    alert(`Porto alterado`)
                    await this.setState({finalizaOperacao: true})
                }else{
                    await alert(`Erro`)
                }
            },
            async res => await alert(`Erro: ${res.data}`)
           )
       }
   }



    erroApi = async (res) => {
        alert(PRECISA_LOGAR)
        await this.setState({redirect: true})
    }

    limpaControles = async () => {
        await this.setState({name: ''})
    }

    fileSelectedHandler = async (event) => {
        console.log(event.target.files[0])
        await this.setState(
            {
                thumb: [URL.createObjectURL(event.target.files[0])], 
                imagem: event.target.files[0]
            }
        )
        console.log('fotos: ' + this.state.imagem)
    }
    verificarspans = () => {
        if(this.state.name && this.state.name.trim().length >= 4){
            this.setState({spanerror1:''})
        }else {
            this.setState({spanerror1:'Nome Invalido'})
        }
        if(this.state.thumb[0] && this.state.thumb != []) {
            this.setState({spanerror2:''})
        }else{
            this.setState({spanerror2:'Sem foto'})
        }
    }

    render(){
        
        const validations = []
        validations.push(this.state.name && this.state.name.trim().length >= 4)
        validations.push(this.state.thumb[0] && this.state.thumb != [])
        //o formulário só será válido se todas as validações forem verdadeiras, com este reduce implementado
        const validForm = validations.reduce((t, a) => t && a)
        
        return (
            <div>
                {this.state.redirect &&
                    <Redirect to={'/admin'} />
                }
                {this.state.finalizaOperacao &&
                    <Redirect to={'/admin/seaports'} />
                }
                <section className="page-add">
                    <Header voltarSeaport/>
                    
                        <div className="row">
                            <div className="col-2"></div>
                            <div className="col-8">
                                <div className="page-breadcrumb">
                                    <h2 style={{marginBottom: '3%', marginTop: '3%'}}>{parseInt(this.state.id) === 0 ? 'Inserir novo porto' : 'Alterar porto'}</h2>
                                </div>
                            </div>
                            <div className="col-2"></div>
                        </div>



                </section>

                <div className="contact-section">
                    
                        <div className="row" onBlur={() => {this.verificarspans()}} >
                            <div className="col-lg-12">
                                <Formik 
                                initialValues={{
                                    name: '',
                                }}
                                onSubmit={async values => {
                                    await new Promise(r => setTimeout(r, 1000))
                                    this.salvarPorto()
                                }}
                                >
                                    <Form className="contact-form">

                                    <div className="row">
                                        <div className="col-2"></div>
                                        <div className="col-8 text-left">
                                            <div className="row">
                                                <div className="col-2">
                                                    <label htmlFor="name">Nome</label>
                                                </div>
                                                <div className="col-10">
                                                    <Field name="name" id="name" placeholder="Seaport Name" type="text" value={this.state.name} onChange={async e => { await this.setState({name: e.currentTarget.value})}}/>
                                                    <span className='spanerror'>{this.state.spanerror1}</span>
                                                </div>
                                                <div className="col-2">
                                                    <label htmlFor="information">Descrição</label>
                                                </div>
                                                <div className="col-10">
                                                    <textarea 
                                                        className="form-control" 
                                                        value={this.state.information} 
                                                        rows={4}
                                                        name="information"
                                                        id="information"
                                                        onChange={async e => { await this.setState({information: e.currentTarget.value})}} 
                                                    />
                                                </div>
                                                <div className="col-2">
                                                    <label htmlFor="file">Imagem</label>
                                                </div>
                                                <div className="col-10">
                                                    <input type="file" name="file" className="form-control-lg" accept="image/png" onChange={this.fileSelectedHandler}/>
                                                    <span className='spanerror'>{this.state.spanerror2}</span>
                                                </div>

                
                                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                                                    <Image src={this.state.thumb[0]} thumbnail fluid style={{maxHeight: 250, maxWidth: 250}}/> 
                                                </div>
                                            
                                            </div>  
                                        </div>
                                         <div className="col-2"></div>
                                    </div>
                                    
                                    <div className="row">
                                        <div className="col-2"></div>
                                        <div className="col-8 dxnomeio" style={{display:'flex', justifyContent:'center',}}>
                                            <button disabled={!validForm} type="submit" style={validForm ? {width:300} : {width:300, backgroundColor: '#eee', opacity: 0.3} } >{parseInt(this.state.id) === 0 ? 'Salvar' : 'Alterar'}</button>
                                        </div>
                                        <div className="col-2"></div>
                                    </div>

                                    </Form>
                                </Formik>
                            </div>
                        </div>
                    
                </div>
            </div>
        )
        
    }
}

const mapStateToProps = ({user, servidor}) => {
    return{
        token: user.token,
        online: servidor.online
    }
}

export default connect(mapStateToProps, null)(AddSeaport)

/*
    salvarPorto = async () => {
        if(this.state.id == 0){
            if(this.props.online){
                await api.post(`seaports`, {name: this.state.name}, {
                    headers: {
                        "Authorization": `bearer ${this.props.token}`
                    }
                }
                ).then(
                    response => {
                        if(response.status === 204){
                            alert("Porto inserido corretamente!")
                            this.limpaControles()
                        }else{
                            alert("Erro na inserção! Tente novamente!")
                        }
                    },
                    response => {
                        this.erroApi(response)
                    }
                )
            }else{
                await apiLocal.post(`seaports`, {name: this.state.name}, {
                    headers: {
                        "Authorization": `bearer ${this.props.token}`
                    }
                }
                ).then(
                    response => {
                        if(response.status === 204){
                            alert("Porto inserido corretamente!")
                            this.limpaControles()
                        }else{
                            alert("Erro na inserção! Tente novamente!")
                        }
                    },
                    response => {
                        this.erroApi(response)
                    }
                )
            }
        }else{
            if(this.props.online){
                await api.put(`seaports/${this.state.id}`, {
                    name: this.state.name,
                }, {
                    headers: {
                        "Authorization": `bearer ${this.props.token}`
                    }
                }).then(response => {
                    if(response.status === 204){
                        alert("Porto alterado corretamente!")
                    }else{
                        alert("Erro na alteração! Tente novamente!")
                    }
                })
            }else{
                await apiLocal.put(`seaports/${this.state.id}`, {
                    name: this.state.name,
                }, {
                    headers: {
                        "Authorization": `bearer ${this.props.token}`
                    }
                }).then(response => {
                    if(response.status === 204){
                        alert("Porto alterado corretamente!")
                    }else{
                        alert("Erro na alteração! Tente novamente!")
                    }
                })
            }
        }
    }

    loadData = async (produto) => {
        try{
            if(this.props.online){
                await api.get(`seaports/${produto}` , {
                    headers: {
                        "Authorization": `bearer ${this.props.token}`
                    }
                }).then(
                    response => {this.setState({name: response.data.name})},
                    response => this.erroApi(response)
                )
            }else{
                await apiLocal.get(`seaports/${produto}` , {
                    headers: {
                        "Authorization": `bearer ${this.props.token}`
                    }
                }).then(
                    response => {this.setState({name: response.data.name})},
                    response => this.erroApi(response)
                )
            }
        }catch(e){
            alert(e)
        }
    }
    */
    
